import { Icon, IconProps } from '@elkaso-app/web-design';

export const ArrowIcon = (props: IconProps) => {
  return (
    <Icon width='11px' height='6px' viewBox='0 0 11 6' fill='gray.500' {...props}>
      <path d='M10.5 5.5L5.5 0.5L0.5 5.5L10.5 5.5Z' fill='inherit' />
    </Icon>
  );
};
